import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { ArrowRight } from 'lucide-react'

import { Alert, AlertDescription } from '@/shared/ui/alert'
import { Button } from '@/shared/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/shared/ui/dialog'

export function DaycareBanner() {
    const [isDialogOpen, setIsDialogOpen] = useState(false)
    const navigate = useNavigate()
    const { t } = useTranslation()

    return (
        <>
            <Alert
                className='group mt-6 bg-yellow-50 px-3 transition-colors hover:bg-yellow-100/80 sm:px-4'
                onClick={() => setIsDialogOpen(true)}
            >
                <div className='flex flex-col items-start justify-between gap-2'>
                    <div className='flex flex-col'>
                        <div className='flex items-center gap-2'>
                            <AlertDescription className='text-sm font-medium text-yellow-800 sm:text-base'>
                                {t(
                                    'daycareBanner.message',
                                    '¿Recogida más tarde de las 16:00? Contrata nuestro servicio de guardería.',
                                )}
                            </AlertDescription>
                        </div>
                    </div>
                    <div className='flex w-full justify-end'>
                        <div
                            className='flex cursor-pointer items-center gap-1 text-yellow-800 hover:bg-yellow-200/60'
                            aria-label={t('daycareBanner.button', 'Reservar')}
                        >
                            <span className='text-sm'>{t('daycareBanner.button', 'Reservar')}</span>
                            <ArrowRight className='h-4 w-4 transform transition-transform group-hover:translate-x-1' />
                        </div>
                    </div>
                </div>
            </Alert>

            <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
                <DialogContent className='w-[95vw] sm:w-full sm:max-w-[425px]'>
                    <DialogHeader>
                        <DialogTitle className='text-lg sm:text-xl'>
                            {t('daycareBanner.dialogTitle', 'Servicio de Guardería')}
                        </DialogTitle>
                        <DialogDescription className='space-y-2 pt-2'>
                            {t(
                                'daycareBanner.dialogDescription',
                                'Podrás agregar los servicios de peluquería que necesites.',
                            )}
                        </DialogDescription>
                    </DialogHeader>
                    <DialogFooter className='sm:justify-end'>
                        <Button onClick={() => navigate('/booking')} className='w-full gap-2 sm:w-auto'>
                            {t('daycareBanner.dialogButton', 'Ir al motor de reservas de hotel')}
                            <ArrowRight className='h-4 w-4' />
                        </Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </>
    )
}
